// extracted by mini-css-extract-plugin
module.exports = {"padding":"CreateRuleForm_padding__1cpGH"};